// extracted by mini-css-extract-plugin
module.exports = {"ldsRipple":"location-loader-module__ldsRipple___Ej9l-","lds-ripple":"location-loader-module__lds-ripple___+2tkD"};